import { trackEvent } from "../../../trackEvent";
import getLinkText from "../../../helpers/getLinkText";
import { normalizeWhitespace } from "../../../../../helpers/stringHelpers"

const test = ({ target }) => !!target.closest(".announcement a");

const push = ({ link, target }) => {
  const linkText = getLinkText({ target });

  trackEvent({
    event: "click_bar",
    event_type: "click",
    element_text: normalizeWhitespace(linkText)  || "none",
    element_url: link,
  });
};

export default {
  name: "announcementBar",
  test,
  push,
};

